import {
  FormElement,
  INPUT_NUMBER_VARIANT_DANGER,
  InputNumber
} from 'mailup-web-components'
import { step2State } from 'Pages/Workflow/recoil/state/step2'
import { useState } from 'react'

import { useIntl } from 'react-intl'

import { useRecoilValue, useSetRecoilState } from 'recoil'

const MIN_INPUT_VALUE = 0
const MAX_INPUT_VALUE = 99999999

const InputFieldValueNumeric = () => {
  const intl = useIntl()

  const { FieldValue } = useRecoilValue(step2State)
  const setWorkflowDetailsState = useSetRecoilState(step2State)

  const [value, setValue] = useState(parseInt(FieldValue) || 0)
  const [isDirty, setIsDirty] = useState(false)

  const handleFieldValueChange = (value) => {
    setWorkflowDetailsState((prev) => ({
      ...prev,
      FieldValue: `${value}`
    }))
    setValue(value)
    setIsDirty(true)
  }

  const wrongFormatFeedback = intl.formatMessage({
    id: 'Load.TrustedEmailInput.WrongFormatMessage'
  })

  const invalid =
    isDirty && typeof value !== 'number' && !`${value}`.match(/^\d{1,8}$/)

  const parser = (x) => {
    const result = x.replace(/^(\d{0,8})(.*)/, '$1')
    return result
  }

  return (
    <FormElement
      label={intl.formatMessage({
        id: 'Load.AutomationWorkflow.InputCustomLabel'
      })}
      required
      feedback={invalid ? wrongFormatFeedback : undefined}
      variant={invalid ? 'danger' : undefined}
    >
      <InputNumber
        min={MIN_INPUT_VALUE}
        max={MAX_INPUT_VALUE}
        value={value}
        onChange={handleFieldValueChange}
        variant={invalid ? INPUT_NUMBER_VARIANT_DANGER : undefined}
        precision={0}
        parser={parser}
      />
    </FormElement>
  )
}

export default InputFieldValueNumeric
